import { useNavigate, useParams } from "react-router-dom";
import CardHeader from "../../../antd/components/CardHeader";
import * as yup from 'yup';
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { Collapse, InputGroup } from "react-bootstrap";
import { useContext, useState } from "react";
import CurrencyInput from 'react-currency-input-field';
import './styles.css';
import useLoading from "../../../Hooks/useLoading";
import Loader from "../../../Components/Shared/Loader";
import { IResponseProps } from "../../../Interfaces/IResponseProps";
import { toast } from "react-toastify";
import { CreateProjectHistoryAPI} from "../../../API/ProjectHistoryAPI";
import { AuthContext } from "../../../Contexts/AuthContext";
import { AllStatus } from "../../../Utils/AllContratTypes";
//import Select from 'react-select';
import { ISelectProps } from "../../../Interfaces/ISelectProps";
import TextField from "@mui/material/TextField";
import { Button, InputLabel, MenuItem, Select } from "@mui/material";

interface FormSubmitProps {
    projectName: string;
    activities: string;
}

const CreateProjectHistory = () => {
    const { id, type } = useParams();
    const { loading, toggleLoading } = useLoading();
    const { userEmail } = useContext(AuthContext);
    const [open, setOpen] = useState<boolean>(false);
    const [budget, setBudget] = useState<string>("0");
    const [RhValue, setRhValue] = useState<string>("0");
    const [infraValue, setInfraValue] = useState<string>("0");
    const [invoicesValue, setInvoicesValue] = useState<string>("0");
    const [equipmentValue, setEquipmentValue] = useState<string>("0");
    const [inProgress, setInProgress] = useState<boolean>(false);
    const navigate = useNavigate();

    const schema = yup.object().shape({
        projectName: yup.string().required("Por favor, insira um nome ao projeto!"),
        activities: yup.string().required("Por favor, insira uma atividade!"),
    });

    const { register, handleSubmit, formState: { errors } } = useForm<FormSubmitProps>({
        resolver: yupResolver(schema)
    });

    const sumBudget = () => {
        let result = parseFloat(RhValue.replace(",", ".")) + parseFloat(infraValue.replace(",", ".")) + parseFloat(invoicesValue.replace(",", ".")) + parseFloat(equipmentValue.replace(",", "."));

        setBudget(result.toFixed(2).toString());
    }

    const setZeroForAll = () => {
        let result = parseFloat(RhValue) + parseFloat(infraValue) + parseFloat(invoicesValue) + parseFloat(equipmentValue);

        if (result != parseFloat(budget)) {
            setRhValue("0");
            setEquipmentValue("0");
            setInfraValue("0");
            setInvoicesValue("0");
        }
    }

    const Submit = async (data: any) => {
        try {
            toggleLoading(true);

            let projectName = data.projectName ?? "";
            let activities = data.activities ?? "";

            await CreateProjectHistoryAPI(id ?? "", userEmail, projectName, activities, parseInt(type ?? "0"), budget.replace(",", "."), RhValue.replace(",", "."), equipmentValue.replace(",", "."), invoicesValue.replace(",", "."), infraValue.replace(",", "."), inProgress).then((resp: IResponseProps) => {
                if (resp.statusCode === 200) {
                    toast.success(`Projeto ${projectName} criado com sucesso!`);
                    navigate(`/projectInformation/${id}`);
                }
            }).finally(() => {
                toggleLoading(false);
            });
        }
        catch (error: any) {
            toast.error(error);
            toggleLoading(false);
        }
    }

    return (
        <div className='card ml-2 mr-2'>
            {loading && <Loader />}
            <CardHeader
                pageName={"Novo Projeto"}
                hasPageBefore={true}
                linkPageBefore={`/projectInformation/${id}`}
                pageBeforeName={"Informações de Projetos"}
            />
            <div className='card-body mt-2 ps-4 pe-4'>
                <form onSubmit={handleSubmit(data => Submit(data))} autoComplete='false' id="formProjects" method='POST'>
                    <div className="mb-4">

                        <TextField

                            className='form-control mt-2'
                            required
                            id="outlined-required"
                            label="Nome do Projeto a Apresentar:"
                            placeholder="Insira um nome.."
                            {...register("projectName")}
                            error={!!errors.projectName}
                            helperText={errors.projectName?.message}
                        />
                       
                    </div>
                    <div className="mb-4">

                        <TextField
                            className="form-control mt-2"
                            required
                            {...register("activities")}
                            label="Atividades Associadas ao Projeto: "
                            placeholder="Insira as atividades.."
                            multiline
                            minRows={5}
                            error={!!errors.activities}
                            helperText={errors.activities?.message}
                        />
                    </div>
                    <div className="mb-4 mt">
                        <InputLabel required >Orçamento Estimado do Projeto: </InputLabel>
                        <div className='border-round-in-top card-header d-flex align-items-center justify-content-between cursor-pointer w-100 mt-2' onClick={() => setOpen(!open)}>
                            <InputGroup className='container-relative input-main'>
                                <InputGroup.Text>R$</InputGroup.Text>
                                <CurrencyInput
                                    id="input-example"
                                    name="input-name"
                                    className='form-control input-main'
                                    intlConfig={{ locale: 'pt-BR' }}
                                    placeholder="0,00"
                                    value={budget}
                                    onBlur={setZeroForAll}
                                    onClick={(e: any) => e.stopPropagation()}
                                    decimalsLimit={2}
                                    onValueChange={(value: any, name: any) => setBudget(value ? value : 0)}
                                />
                            </InputGroup>
                            {open ?
                                <FaChevronUp className="font-awesome-icon" />
                                :
                                <FaChevronDown className="font-awesome-icon" />
                            }
                        </div>
                        <Collapse in={open} className="background-collapse">
                            <div id="collapse" className='p-3'>
                                <div className='d-flex align-items-center'>
                                    <div className="w-100 me-3">
                                        <label>Recursos Humanos:</label>
                                        <InputGroup className='container-relative w-100'>
                                            <InputGroup.Text>R$</InputGroup.Text>
                                            <CurrencyInput
                                                id="input-example"
                                                name="input-name"
                                                className='form-control'
                                                intlConfig={{ locale: 'pt-BR' }}
                                                placeholder="0,00"
                                                value={RhValue}
                                                onBlur={sumBudget}
                                                onClick={(e: any) => e.stopPropagation()}
                                                decimalsLimit={2}
                                                onValueChange={(value: any, name: any) => setRhValue(value ? value : 0)}
                                            />
                                        </InputGroup>
                                    </div>
                                    <div className="w-100 ms-3">
                                        <label>Infraestrutura:</label>
                                        <InputGroup className='container-relative w-100'>
                                            <InputGroup.Text>R$</InputGroup.Text>
                                            <CurrencyInput
                                                id="input-example"
                                                name="input-name"
                                                className='form-control'
                                                intlConfig={{ locale: 'pt-BR' }}
                                                placeholder="0,00"
                                                value={infraValue}
                                                onBlur={sumBudget}
                                                onClick={(e: any) => e.stopPropagation()}
                                                decimalsLimit={2}
                                                onValueChange={(value: any, name: any) => setInfraValue(value ? value : 0)}
                                            />
                                        </InputGroup>
                                    </div>
                                </div>
                                <div className='d-flex align-items-center mt-4'>
                                    <div className="w-100 me-3">
                                        <label>Serviços de Terceiros:</label>
                                        <InputGroup className='container-relative w-100'>
                                            <InputGroup.Text>R$</InputGroup.Text>
                                            <CurrencyInput
                                                id="input-example"
                                                name="input-name"
                                                className='form-control'
                                                intlConfig={{ locale: 'pt-BR' }}
                                                placeholder="0,00"
                                                value={invoicesValue}
                                                onBlur={sumBudget}
                                                onClick={(e: any) => e.stopPropagation()}
                                                decimalsLimit={2}
                                                onValueChange={(value: any, name: any) => setInvoicesValue(value ? value : 0)}
                                            />
                                        </InputGroup>
                                    </div>
                                    <div className="w-100 ms-3">
                                        <label>Aquisição de Equipamentos (Nacional ou Importado):</label>
                                        <InputGroup className='container-relative w-100'>
                                            <InputGroup.Text>R$</InputGroup.Text>
                                            <CurrencyInput
                                                id="input-example"
                                                name="input-name"
                                                className='form-control'
                                                intlConfig={{ locale: 'pt-BR' }}
                                                placeholder="0,00"
                                                value={equipmentValue}
                                                onBlur={sumBudget}
                                                onClick={(e: any) => e.stopPropagation()}
                                                decimalsLimit={2}
                                                onValueChange={(value: any, name: any) => setEquipmentValue(value ? value : 0)}
                                            />
                                        </InputGroup>
                                    </div>
                                </div>
                            </div>
                        </Collapse>
                    </div>
                    {type == "1" &&
                        <div className='border-round card-header d-flex align-items-center w-100 mt-2 mb-4'>

                            <Select
                                className="form-select w-25 ms-3"
                                id="demo-simple-select"
                                value={inProgress.toString()}
                                label="Projeto em Andamento?"
                                onChange={(e) => setInProgress(JSON.parse(e.target.value))}
                            >
                                <MenuItem value="false">Não</MenuItem>
                                <MenuItem value="true">Sim</MenuItem>
                            </Select>
                        </div>
                    }
                    {/* <div className='border-round card-header d-flex align-items-center w-100 mt-2 mb-4'>
                        <InputLabel required >Qual a modalidade do Financiamento? </InputLabel>

                        <Select
                            
                            className="w-25 ms-3"
                            value={contractType}
                            onChange={(e: any) => { setContractType(e.target); setContractTypeText(e.target.value) }}
                            placeholder="Select"
                            style={{ background: 'white' }}
                        >
                            {AllStatus.map(option => (
                                <MenuItem key={option.value} value={option.value}>
                                    {option.label}
                                </MenuItem>
                            ))}
                        </Select>

                    </div> */}
                    <Button variant="contained" type='submit' className='btn btn-primary w-100 mb-3 mt-4'>
                        Salvar Projeto
                    </Button>
                </form>
            </div>
        </div>
    )
}

export default CreateProjectHistory;